import React from 'react';
// Image from next/image removed - use regular img tag;
import { 
  MdChevronLeft,
  MdChevronRight,
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdMenu,
  MdClose,
  MdChat
} from 'react-icons/md';
import {
  FiMoon,
  FiSun,
  FiCheckCircle,
  FiTrendingUp,
  FiActivity,
  FiMessageCircle,
  FiPlus,
  FiCalendar,
  FiBarChart,
  FiMoreHorizontal,
  FiCircle,
  FiClock,
  FiXCircle,
  FiMessageSquare,
  FiPieChart,
  FiLink,
  FiLink2,
  FiSettings,
  FiUser,
  FiShield,
  FiZap,
  FiBell,
  FiDownload,
  FiCode,
  FiBookOpen,
  FiFolder,
  FiGitBranch,
  FiTrendingUp as FiBrain,
  FiDatabase,
  FiSearch,
  FiCheck,
  FiCheckSquare,
  FiX,
  FiAlertTriangle,
  FiEdit3,
  FiMail,
  FiUsers,
  FiInbox,
  FiHome,
  FiFileText,
  FiBarChart2,
  FiVolume2,
  FiMic,
  FiRefreshCw,
  FiShare2,
  FiImage,
  FiAward,
  FiTool,
  FiPlay,
  FiPause,
  FiStar,
  FiCrop,
  FiPenTool,
  FiMonitor,
  FiHelpCircle,
  FiUpload,
  FiTerminal,
  FiDroplet,
  FiKey,
  FiUserCheck,
  FiTrash2,
  FiDownloadCloud,
  FiAlertCircle,
  FiEdit,
  FiMapPin,
  FiGlobe,
  FiInfo,
  FiDollarSign,
  FiCreditCard,
  FiPaperclip,
  FiPercent,
  FiLoader,
  FiTarget,
  FiArrowLeft,
  FiArrowUp,
  FiArrowDown,
  FiMaximize2,
  FiLayers,
  FiGrid,
  FiBriefcase,
  FiCpu,
  FiSave,
  FiToggleLeft,
  FiToggleRight,
  FiRepeat,
  FiList,
  FiSend,
  FiFilter,
  FiFlag,
  FiHash,
  FiEye,
  FiEyeOff,
  FiSlash,
  FiMinusCircle,
  FiArchive,
  FiPhone,
  FiWatch,
  FiSmile,
  FiPackage,
  FiWifiOff
} from 'react-icons/fi';
import { GiTestTubes } from 'react-icons/gi';
import { FaWhatsapp, FaInstagram, FaFacebookMessenger } from 'react-icons/fa';

interface IconProps {
  name?: string;
  src?: string; // For custom icons from /public/icons/
  size?: number;
  color?: string; // Icon color
  className?: string;
  style?: React.CSSProperties;
  alt?: string; // Alt text for custom icons
}

const Icon: React.FC<IconProps> = ({ name, src, size = 20, color, className = '', style, alt }) => {
  // If src is provided, render custom icon
  if (src) {
    return (
      <img
        src={src}
        alt={alt || 'Icon'}
        width={size}
        height={size}
        className={className}
        style={style as any}
      />
    );
  }

  // If no name provided, return null
  if (!name) {
    console.warn('Icon component requires either name or src prop');
    return null;
  }

  // Icon mapping - fallback react-icons for non-custom icons
  const iconComponents: Record<string, any> = {
    // UI icons (fallbacks only - navigation uses custom icons)
    chevronLeft: MdChevronLeft,
    chevronRight: MdChevronRight,
    chevronUp: MdKeyboardArrowUp,
    chevronDown: MdKeyboardArrowDown,
    menu: MdMenu,
    close: MdClose,
    chat: MdChat,
    moon: FiMoon,
    sun: FiSun,
    // Feather icons
    checkCircle: FiCheckCircle,
    trendingUp: FiTrendingUp,
    trending: FiTrendingUp,
    activity: FiActivity,
    messageCircle: FiMessageCircle,
    plus: FiPlus,
    calendar: FiCalendar,
    chart: FiBarChart,
    moreHorizontal: FiMoreHorizontal,
    circle: FiCircle,
    clock: FiClock,
    xCircle: FiXCircle,
    messageSquare: FiMessageSquare,
    pieChart: FiPieChart,
    link: FiLink,
    settings: FiSettings,
    user: FiUser,
    shield: FiShield,
    zap: FiZap,
    bell: FiBell,
    download: FiDownload,
    code: FiCode,
    bookOpen: FiBookOpen,
    folder: FiFolder,
    gitBranch: FiGitBranch,
    brain: FiBrain,
    database: FiDatabase,
    search: FiSearch,
    check: FiCheck,
    x: FiX,
    alertTriangle: FiAlertTriangle,
    wifiOff: FiWifiOff,
    edit: FiEdit3,
    mail: FiMail,
    users: FiUsers,
    inbox: FiInbox,
    home: FiHome,
    // Tool-specific icons
    'file-text': FiFileText,
    fileText: FiFileText,
    'bar-chart-2': FiBarChart2,
    barChart2: FiBarChart2,
    'book-open': FiBookOpen,
    'volume-2': FiVolume2,
    volume2: FiVolume2,
    mic: FiMic,
    'refresh-cw': FiRefreshCw,
    refreshCw: FiRefreshCw,
    'share-2': FiShare2,
    share2: FiShare2,
    'file-plus': FiPlus,
    filePlus: FiPlus,
    crop: FiCrop,
    image: FiImage,
    award: FiAward,
    'pen-tool': FiPenTool,
    penTool: FiPenTool,
    tool: FiTool,
    grid: FiGrid,
    briefcase: FiBriefcase,
    cpu: FiCpu,
    play: FiPlay,
    star: FiStar,
    monitor: FiMonitor,
    helpCircle: FiHelpCircle,
    'help-circle': FiHelpCircle,
    upload: FiUpload,
    terminal: FiTerminal,
    palette: FiDroplet,
    key: FiKey,
    'user-check': FiUserCheck,
    userCheck: FiUserCheck,
    'trash-2': FiTrash2,
    trash2: FiTrash2,
    'download-cloud': FiDownloadCloud,
    downloadCloud: FiDownloadCloud,
    'alert-circle': FiAlertCircle,
    alertCircle: FiAlertCircle,
    'edit-2': FiEdit,
    edit2: FiEdit,
    'edit-3': FiEdit3,
    edit3: FiEdit3,
    'map-pin': FiMapPin,
    mapPin: FiMapPin,
    globe: FiGlobe,
    info: FiInfo,
    // Additional icons
    link2: FiLink2,
    layers: FiLayers,
    dollarSign: FiDollarSign,
    creditCard: FiCreditCard,
    barChart: FiBarChart,
    checkSquare: FiCheckSquare,
    paperclip: FiPaperclip,
    percent: FiPercent,
    loader: FiLoader,
    pause: FiPause,
    trophy: FiAward,
    target: FiTarget,
    arrowLeft: FiArrowLeft,
    arrowUp: FiArrowUp,
    arrowDown: FiArrowDown,
    expand: FiMaximize2,
    // Custom icons that don't exist in react-icons, use alternatives
    piggyBank: FiDollarSign, // Using dollar sign as fallback
    calculator: FiPercent, // Using percent as fallback
    chartLine: FiTrendingUp, // Using trending up as fallback
    fire: FiZap, // Using zap as fallback
    sparkles: FiStar, // Using star as fallback
    lightbulb: FiZap, // Using zap as fallback
    // Additional icons for configuration panels
    save: FiSave,
    send: FiSend,
    toggleLeft: FiToggleLeft,
    toggleRight: FiToggleRight,
    repeat: FiRepeat,
    list: FiList,
    trash: FiTrash2,
    // Debug panel icons
    filter: FiFilter,
    flag: FiFlag,
    hash: FiHash,
    eye: FiEye,
    eyeOff: FiEyeOff,
    slash: FiSlash,
    minusCircle: FiMinusCircle,
    archive: FiArchive,
    // Conversation icons
    smile: FiSmile,
    phone: FiPhone,
    timer: FiWatch,
    flask: GiTestTubes,
    // Offerings
    package: FiPackage,
    // Brand icons for channels
    whatsapp: FaWhatsapp,
    instagram: FaInstagram,
    facebookMessenger: FaFacebookMessenger,
  };

  // Custom icon paths - using your custom navigation icons
  const customIconPaths: Record<string, string> = {
    // Navigation icons (your custom icons)
    dashboard: '/icons/navigation/dashboard.svg',
    beehive: '/beehive.svg',
    inbox: '/icons/navigation/inbox.svg',
    knowledge: '/icons/navigation/knowledge.svg',
    tools: '/icons/navigation/tools.svg',
    settings: '/icons/navigation/settings.svg',
    
    // UI icons
    customClose: '/icons/ui/example-close.svg',
  };

  // Check if it's a custom icon first
  if (customIconPaths[name]) {
    return (
      <img
        src={customIconPaths[name]}
        alt={alt || name}
        width={size}
        height={size}
        className={className}
        style={style as any}
      />
    );
  }

  // Color mapping for UI icon types (navigation icons use their own colors)
  const getIconColor = (iconName: string): string => {
    const colorMap: Record<string, string> = {
      // UI icon colors
      chevronLeft: 'currentColor',
      chevronRight: 'currentColor',
      menu: 'currentColor',
      close: 'currentColor',
      chat: 'currentColor',
      moon: '#F59E0B', // Amber
      sun: '#F59E0B', // Amber
    };
    return colorMap[iconName] || 'currentColor';
  };

  const IconComponent = iconComponents[name];
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  const finalIconStyle = {
    color: color || getIconColor(name),
    ...style
  };

  return (
    <IconComponent
      size={size}
      className={className}
      style={finalIconStyle}
    />
  );
};

export default Icon;
